import React, { useRef } from "react";
import "react-form-wizard-component/dist/style.css";
import "./stepwizard.scss";
import Fulfilment from "../Fulfilment";
import Payment from "../Payment";
import Order from "../Order";
import { Iprops } from "./stepwizardinterface";
import FormWizard from "react-form-wizard-component";
import { useTranslation } from 'react-i18next';
import { RESOURCE } from '../../../const/resource';
import { useCartContext } from '../../ShoppingCart/shoppingcart';
import { ICartContextType } from "../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface";

const Stepwizard = (props: Iprops) => {
    const { t } = useTranslation();
    const { updateStepIndex, isHideItemSummary }: ICartContextType = useCartContext();

  const handleComplete = () => {
    console.log("Form completed!");
  };
  const tabChanged = ({
    prevIndex,
    nextIndex,
  }: {    prevIndex: any;
    nextIndex: number;
  }) => {
    if (prevIndex?.nextIndex) {
      updateStepIndex(prevIndex?.nextIndex)
    }
  };
  const changeindexone = () => {
    props.formWizardRef.current?.goToTab(0);
  };
  const changeindextwo = () => {
    props.formWizardRef.current?.goToTab(1);
  };
  const changeindexthree = () => {
    props.formWizardRef.current?.goToTab(2);
  };

    const fulfillmentShipmentTitle = `${t(RESOURCE.MyK_Label_SC_Fulfilment)} + ${t(RESOURCE.MyK_Label_SC_Shipping)}`;

    const baseRef = {
      savedAddress: useRef<HTMLDivElement>(null),
      firstName: useRef<HTMLDivElement>(null),
      lastName: useRef<HTMLDivElement>(null),
      address1: useRef<HTMLDivElement>(null),
      city: useRef<HTMLDivElement>(null),
      countryName: useRef<HTMLDivElement>(null),
      stateName: useRef<HTMLDivElement>(null),
      postalCode: useRef<HTMLDivElement>(null)};
      
  return (
    <>
      <div className={`stepwizard ${isHideItemSummary ? 'hide' : ''}`}>
        <FormWizard
          ref={props.formWizardRef}
          onComplete={handleComplete}
          onTabChange={(prevIndex: number, nextIndex: number) => tabChanged({ prevIndex, nextIndex })}>
                  <FormWizard.TabContent title={fulfillmentShipmentTitle}>
                          <Fulfilment
                              getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading}
                              getAvailabilityDetails={props?.getAvailabilityDetails}
                              fulfillmentDetailRes={props?.fulfillmentDetailRes}
                              availabilityDetails={props?.availabilityDetails}
                              getIsNextDisableStatus={props?.getIsNextDisableStatus}
                              updateStepperDetails={props?.updateStepperDetails}
                              getAvailablePartsDetails={props?.getAvailablePartsDetails}
                              getDivRef={props?.getDivRef}
                              phoneCodeOption={props?.phoneCodeOption}
                              shoppingcartOnClick={props?.shoppingcartOnClick}
                              saveFulfillmentType={props?.saveFulfillmentType}
                              isNextClick={props?.isNextClick}
                              baseRef={baseRef}
                          />
          </FormWizard.TabContent>
          <FormWizard.TabContent title={t(RESOURCE.MyK_Label_SC_Payment)}>
            <Payment itemSummaryDetails={props.itemSummaryDetails} cartsDetails={props.cartsDetails}
              updateStepperDetails={props?.updateStepperDetails}
              getDivRef={props?.getDivRef}
              isNextClick={props?.isNextClick}
              baseRef={baseRef}
            />
          </FormWizard.TabContent>
          <FormWizard.TabContent title={t(RESOURCE.MyK_Label_SC_Order)} >
             <Order
              isPromoChanges={props.isPromoChanges}
              changeindexthree={changeindexthree}
              changeindextwo={changeindextwo}
              changeindexone={changeindexone}
              scrollToDiv={props?.scrollToDiv}
              updateStepperDetails={props?.updateStepperDetails}
            />
          </FormWizard.TabContent>
        </FormWizard>
      </div>
      {/* add style */}
      <style>{`
          @import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");
        `}</style>
    </>
  );
};

export default Stepwizard;
